export default "__VITE_ASSET__D59zuX2r__"